import { render, staticRenderFns } from "./SamplePhoto.vue?vue&type=template&id=b24471cc&scoped=true&"
import script from "./SamplePhoto.vue?vue&type=script&lang=js&"
export * from "./SamplePhoto.vue?vue&type=script&lang=js&"
import style0 from "./SamplePhoto.vue?vue&type=style&index=0&id=b24471cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24471cc",
  null
  
)

export default component.exports